<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2025-08-26 14:35:04
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2025-08-26 15:40:59
 * @FilePath: \front\src\layout\components\Sidebar\components\SiteMenu\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-menu :default-active="menuActive" :unique-opened="true" @select="onSelect">
    <template v-for="item in menu">
      <SubMenu :data="item" :key="item.id"></SubMenu>
    </template>
  </el-menu>

</template>

<script>
import SubMenu from './sub-menu.vue';

export default {
  name: 'SiteMenu',
  components: { SubMenu },
  props: {
    menu: Array,
    menuActive: String,
  },
  methods: {

    onSelect(data) {
      this.$emit('select', data);
    },

  }
}
</script>

<style lang="less">
.el-submenu__title {
  span {
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
  }
}
</style>